import { RG_TYPE as r } from "@project-rouge/rg-core";
import { getMaxFfl as s } from "./scalar-metrics/total-metrics/index33.js";
import { getProjectionArea as i } from "./scalar-metrics/total-metrics/index44.js";
const p = 11;
function c(e, l, a) {
  const o = e.children.filter((t) => t.type === r.Apartment).map((t) => t), n = {
    Levels: new Set(e.data.levels.filter((t) => !t.isRoof).map((t) => t.levelIndex)).size,
    FloorArea: i(e),
    Units: e.children.filter((t) => t.type === r.Apartment).length,
    Ffl: s(e),
    Units1B1P: o.filter((t) => t.data.occupants === 1 && t.data.bedrooms === 1).length,
    Units2B: o.filter((t) => t.data.bedrooms === 2).length,
    Units1B2P: o.filter((t) => t.data.occupants === 2 && t.data.bedrooms === 1).length,
    UnitsStudio: o.filter((t) => t.data.studio).length,
    CoreShafts: e.children.filter((t) => t.data.level === 0 && t.type === r.Core).length,
    FirefightingLifts: e.children.some((t) => t.type === r.Core && t.data.hasFireLift),
    PassengerLifts: e.children.some((t) => t.type === r.Core && (t.data.hasFireLift || t.data.hasNonFireLift)),
    Sprinklered: Math.max(...e.data.levels.map((t) => t.floorWorldBottom)) >= p ? !0 : a == null ? void 0 : a.Sprinklered
  };
  return Object.assign({
    City: "London",
    Units: 0,
    Ffl: 0,
    Levels: 0,
    LevelHeight: 0,
    PodiumHeight: 0,
    MaxModuleDepth: 0,
    FloorArea: 0,
    CoreShafts: 0
  }, l, a, n);
}
export {
  c as getBuildingAttributes
};
//# sourceMappingURL=index.js.map
